import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import EmailTemplateList from "../../components/EmailTemplateList/EmailTemplateList";
import { GeneralStyle } from "./EmailTemplateContainer.styled";
import { useLazyQuery, useMutation } from "@apollo/client";
import { ALL_EMAIL_TEMPLATES } from "../../GraphQL/Queries";
import { EMAIL_TEMPLATE_CHANGE_STATE } from "../../GraphQL/Mutations";
import { clientWellness } from "../../App";
import { NotificationManager } from "react-notifications";
import HeaderComponent from "../../components/Header/Header";
import { ReactComponent as SiteManagementHeaderIcon } from "../../assets/svg/site-management-header-logo.svg";
import { ROLES } from "../../util/RolesConstants";
import { getStateLoginComplete } from "../LayoutHome/stateLogin";

const EmailTemplateContainer = ({ selectedMenu }) => {
  const [userComplete] = useState(getStateLoginComplete());
  const [reloadRender, setreloadRender] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [showCards, setShowCards] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorSelected, setAnchorSelected] = useState(null);
  const history = useHistory();
  const [changeStateEmailTemplate] = useMutation(EMAIL_TEMPLATE_CHANGE_STATE, {
    client: clientWellness,
  });

  const [
    runQueryAllEmailTemplates,
    { loading: loadingAllEmailTemplates, error: errorAllEmailTemplates },
  ] = useLazyQuery(ALL_EMAIL_TEMPLATES, {
    client: clientWellness,
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      const editable = data.allEmailTemplates.map((o) => ({ ...o }));
      if (editable) {
        setDataList(editable);
      }
    },
  });

  let handleCloseActions = () => {
    setAnchorEl(null);
    setAnchorSelected(null);
  };

  let handleClickActions = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    setAnchorSelected(rowData.idEmailTemplate);
  };

  let toggleChecked = (rowData) => {
    if (userComplete.roleId !== ROLES.COUNTRY_ADMIN) {
      let newRecordState =
        rowData.recordState.toUpperCase() === "ACTIVE" ? "INACTIVE" : "ACTIVE";
      changeStateEmailTemplate({
        variables: {
          emailTemplateId: rowData.idEmailTemplate,
          newRecordState: newRecordState,
        },
      }).then(
        (saveResponse) => {
          NotificationManager.success(
            "Your information has been updated, Thank you!",
            "",
            5000
          );
          setreloadRender(!reloadRender);
        },
        (error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        }
      );
    } else {
      NotificationManager.warning("This template cannot be disable.", "", 5000);
    }
  };

  let handleEditEmail = (rowData) => {
    history.push({
      pathname: `/UpdateEmailTemplate`,
      state: { dataEmail: rowData, path: `/EmailTemplates` },
    });
    setAnchorEl(null);
    setAnchorSelected(null);
  };

  useEffect(() => {
    runQueryAllEmailTemplates();
  }, [reloadRender]);

  return (
    <GeneralStyle>
      <HeaderComponent
        Icon={SiteManagementHeaderIcon}
        text={"Site Management"}
      />
      <EmailTemplateList
        reloadRender={reloadRender}
        setreloadRender={setreloadRender}
        loadingEmails={loadingAllEmailTemplates}
        errorEmails={errorAllEmailTemplates}
        dataList={dataList}
        showCards={showCards}
        setShowCards={setShowCards}
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        anchorSelected={anchorSelected}
        setAnchorSelected={setAnchorSelected}
        titleOfTable={""}
        toggleChecked={toggleChecked}
        handleClickActions={handleClickActions}
        handleEditEmail={handleEditEmail}
        handleCloseActions={handleCloseActions}
      />
    </GeneralStyle>
  );
};

export default EmailTemplateContainer;
